<div class="dd-head">
  <div class="dd-title">
    <h2>{{ '@dvirDetail' | translate }}</h2>
    <div class="dd-sub" *ngIf="dvir">
      <span>{{ dvir.dvirCreateDateTimeUtc | date: 'short' }}</span>
      <span class="dd-sep">·</span>
      <span>{{ dvir.vin }}</span>
    </div>
  </div>
  <span class="dd-safety" *ngIf="dvir"
        [class.safe]="dvir.isSafeToOperate" [class.unsafe]="!dvir.isSafeToOperate">
    {{ '@isSafeToOperate' | translate }}: {{ (dvir.isSafeToOperate ? '@yes' : '@no') | translate }}
  </span>
  <button mat-icon-button [attr.aria-label]="'@close' | translate" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="dd-body">
  <div class="dd-loading" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>

  <p class="dd-error" *ngIf="error">{{ '@loadError' | translate }}</p>

  <ng-container *ngIf="dvir && !loading">
    <div class="dd-grid">
      <div>
        <span class="dd-k">{{ '@driver' | translate }}</span>
        <span class="dd-v">{{ driverName(dvir.driver) || '—' }}</span>
      </div>
      <div>
        <span class="dd-k">{{ '@logType' | translate }}</span>
        <span class="dd-v">{{ dvir.logType || '—' }}</span>
      </div>
      <div *ngIf="dvir.certifiedBy">
        <span class="dd-k">{{ '@certifiedBy' | translate }}</span>
        <span class="dd-v">{{ driverName(dvir.certifiedBy) }}</span>
      </div>
    </div>

    <p class="dd-notes" *ngIf="dvir.notes">{{ dvir.notes }}</p>

    <div class="dd-defects">
      <div class="dd-section">{{ '@defectList' | translate }}</div>
      <p class="dd-none" *ngIf="!dvir.defectList?.length">{{ '@noDefects' | translate }}</p>
      <div class="dd-defect" *ngFor="let defect of dvir.defectList">
        <div class="dd-defect-top">
          <span class="dd-defect-name">{{ defect.component }}</span>
          <span class="dd-repair" [class.repaired]="!!defect.repairDateTimeUtc">
            {{ defect.repairStatus || '—' }}
          </span>
        </div>
        <div class="dd-defect-notes" *ngIf="defect.notes">{{ defect.notes }}</div>
        <div class="dd-defect-meta" *ngIf="defect.repairedBy || defect.repairDateTimeUtc">
          <span *ngIf="defect.repairedBy">{{ '@repairedBy' | translate }}: {{ driverName(defect.repairedBy) }}</span>
          <span *ngIf="defect.repairDateTimeUtc">{{ defect.repairDateTimeUtc | date: 'short' }}</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="dd-foot">
  <a mat-button *ngIf="dvir" [routerLink]="fullDvirLink" (click)="onOpenFullDvir($event)">
    {{ '@dvirOpenFull' | translate }}
  </a>
  <span class="dd-sp"></span>
  <button mat-stroked-button (click)="close()">{{ '@close' | translate }}</button>
</div>
